import React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { extractEntityValues, getFormattedEntityList } from './getFormattedEntityList';
import { handleCheckboxChange, handleHeaderCheckboxChange } from './modal_utils';

type SelectPermissionsProps = {
  selectedActions: string[];
  setSelectedActions: React.Dispatch<React.SetStateAction<string[]>>;
  entities: string[];
  actions: string[];
};

export const SelectPermissions = ({
  selectedActions,
  setSelectedActions,
  entities,
  actions,
}: SelectPermissionsProps) => (
  <Paper
    variant='outlined'
    sx={{
      width: '100%',
      my: 2,
      borderRadius: '6px',
      borderColor: 'divider',
      overflow: 'hidden',
    }}
  >
    <TableContainer sx={{ maxHeight: 340 }}>
      <Table size='small' stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ bgcolor: 'rgba(248, 250, 252, 0.95)', fontWeight: 600, fontSize: '0.75rem' }}>
              Entity
            </TableCell>
            {actions.map((action) => (
              <TableCell
                key={action}
                align='center'
                sx={{
                  bgcolor: 'rgba(248, 250, 252, 0.95)',
                  py: 1,
                }}
              >
                <Typography
                  sx={{
                    textTransform: 'capitalize',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    color: 'text.secondary',
                    mb: 0.5,
                  }}
                >
                  {action}
                </Typography>
                <Checkbox
                  size='small'
                  checked={getFormattedEntityList(entities).every((entity) =>
                    selectedActions.includes(`${entity.entityValue}:${action}`),
                  )}
                  onChange={(e) =>
                    handleHeaderCheckboxChange(
                      action,
                      e.target.checked,
                      extractEntityValues(getFormattedEntityList(entities)),
                      selectedActions,
                      setSelectedActions,
                    )
                  }
                />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {getFormattedEntityList(entities).map((entity) => (
            <TableRow key={entity.entityValue} hover>
              <TableCell sx={{ py: 1, fontSize: '0.8125rem', fontWeight: 500 }}>
                {entity.entityLabel}
              </TableCell>
              {actions.map((action) => {
                const entityAction = `${entity.entityValue}:${action}`;
                const isChecked = selectedActions.includes(entityAction);
                return (
                  <TableCell key={entityAction} align='center' sx={{ py: 0.5 }}>
                    <Checkbox
                      size='small'
                      checked={isChecked}
                      onChange={(e) =>
                        handleCheckboxChange(
                          entityAction,
                          e.target.checked,
                          selectedActions,
                          setSelectedActions,
                        )
                      }
                    />
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);
